import{e as i,m as s}from"./chunk-HBP5N4FR.js";var n,x=i(()=>{s();n=t=>!/[^\x00-\x7F]/gm.test(t)});export{n as a,x as b};
//# sourceMappingURL=chunk-SNQ7GR7D.js.map
